import { render } from "./ActiveEvents.vue?vue&type=template&id=15cc1672"
import script from "./ActiveEvents.vue?vue&type=script&lang=js"
export * from "./ActiveEvents.vue?vue&type=script&lang=js"

import "./ActiveEvents.vue?vue&type=style&index=0&id=15cc1672&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__